import { useEffect, useRef } from 'react';
import { useAuthStore } from '../../auth/store/useAuthStore';
import { useSessionStore } from '../session/store/useSessionStore';
import { reportClientPresenceIfDue } from '../clientPresence/reportClientPresence';
import { usePlanEntitlements } from './PlanEntitlementsProvider';
import { canRunOperationalBackgroundWork } from '../session/operationalBackgroundWork';

/**
 * Reporta versión/plataforma cuando hay sesión + org (cooldown 6h).
 */
export function ClientPresenceReporter() {
  const userId = useAuthStore((s) => s.session?.user?.id ?? null);
  const branchId = useSessionStore((s) => s.currentBranchId);
  const { entitlements } = usePlanEntitlements();
  const organizationId = entitlements?.organization_id?.trim() ?? null;
  const lastKeyRef = useRef<string | null>(null);

  useEffect(() => {
    if (!userId || !organizationId || !canRunOperationalBackgroundWork()) {
      return;
    }

    const key = `${userId}:${organizationId}:${branchId ?? ''}`;
    if (lastKeyRef.current === key) {
      return;
    }
    lastKeyRef.current = key;

    void reportClientPresenceIfDue({
      organizationId,
      userId,
      branchId,
    });
  }, [userId, organizationId, branchId]);

  return null;
}
